var $ = require('jquery');
var crossDomain = require('diy/external/crossDomain');
var appsApiConstants = require('diy/external/appsApiConstants');
var moduleSelector = require('diy/site-admin/module-selector/moduleSelector');

(function () {
    var controllerUrl = '/app/siteadmin/appscatalog/';

    var SIZE_STANDARD = 860;
    var SIZE_WIDE = 1164;

    this.windowWidth = window.screen.width < 1280 ? SIZE_STANDARD : SIZE_WIDE;
    this.windowHeight = $(window).height();

    this.customOpen = function(url) {

        if (url) {
            $('#cc-sa-item-appscatalog').data('customHref', url);
        }

        /* if opened close it so we can force open with new url */
        if ($('#cc-sa-item-appscatalog').hasClass('cc-sa-active')) {
            diy.editor.siteadmin.api.close();
            setTimeout(function(){
                $('#cc-sa-item-appscatalog').click();
            }, 350);
        } else {
            $('#cc-sa-item-appscatalog').click();
        }
    };

    this.open = function(url, fromModuleSelector) {
        // add event to open the module selector window
        var buttons = {
            close: {
                event: {
                    type: 'diy-siteadmin-apps-catalog-closed',
                    openModuleSelector: fromModuleSelector
                }
            }
        };

        var self = this;

        // fixed width for the catalog
        var windowBehavior = {
                size: {
                    width: self.windowWidth,
                    height: self.windowHeight,
                    persistentId: ''
                },
                resizable: false,
                footer: {}
        };
        var contentType = 'inline';
        var controllerName = 'appsCatalog';

        var controllerOpenUrl = controllerUrl + 'open/';
        if (url){
            controllerOpenUrl += '?url=' + encodeURIComponent(url);
        }

        diy.editor.siteadmin.api.showWindow(controllerOpenUrl, windowBehavior, contentType, controllerName, 'cc-sa-item-appscatalog');
        diy.editor.siteadmin.api.setSidebarActiveItem('cc-sa-item-appscatalog');
        diy.editor.siteadmin.api.updateTitle(jimdoData.messages.moduleSelector.appsCatalogWindow.title);
        diy.editor.siteadmin.api.updateDescr(jimdoData.messages.moduleSelector.appsCatalogWindow.description);
        diy.editor.siteadmin.api.updateButtons(buttons);
        diy.editor.siteadmin.api.updateHelpTopic('');
    };

    this.updateTopicCategory = function (categoryId) {
        var appsCatalogButton = $('#cc-sa-item-appscatalog');
        appsCatalogButton.attr('href', appsCatalogButton.attr('href').replace(/topicCategory=\d+/, 'topicCategory=' + categoryId));
    };

    this.getDetailPageNoBackLinkUrl = function(webComponentId) {
        var templateUrl = jimdoData.appsCatalogTemplateUrl;
        var url = templateUrl.replace("*WEBCOMPONENT_ID*", webComponentId);
        return url;
    };

    /**
     * this responds to apps catalog request for focus on one web component
     *
     * -it responds back to apps catalog when error encountered
     * -params must contain wc_id and category_id
     *
     * @author marian.cojoc@1and1.ro
     *
     * @param params //TODO: fill this in
     * @param responderObject //TODO: fill this in
     */
    this.cb_handleFocus = function(params, responderObject){
        if(params === undefined
            || params.wc_id === undefined
        ){
            responderObject.error(appsApiConstants.errors.BAD_REQUEST);
        }

        //get the category
        $.ajax(
            {
                url: controllerUrl + 'webapps-get-main-category',
                type: 'POST',
                dataType: 'json',
                data: {wc_id: params.wc_id},
                success: function(msg){

                    if (!msg.data.main_category) {
                        responderObject.error(appsApiConstants.errors.BAD_REQUEST);
                    } else {
                        moduleSelector.default.jumpToWebComponent(params.wc_id, msg.data.main_category);
                    }
                },
                error: function () {
                    responderObject.error(
                        appsApiConstants.errors.INTERNAL_SERVER_ERROR
                    );
                }
            }
        );
    };

    /**
     * this responds to apps catalog request for installation of a web component
     *
     * @author marian.cojoc@1and1.ro
     *
     * @param params //TODO: fill this in
     * @param responderObject //TODO: fill this in
     */
    this.cb_installWebComponent = function (params, responderObject) {
        var wc_id = params.wc_id;

        $.ajax(
            {
                url: controllerUrl + 'webapps-install',
                type: "post",
                dataType: "json",
                data: {wc_id: wc_id},
                success: function(msg){
                    //the response came, get the response
                    if (msg.success === true ) {
                        // Update status cache
                        if ($.inArray(wc_id, jimdoData.installedWebcomponents) === -1) {
                            jimdoData.installedWebcomponents.push(wc_id);
                        }

                        /**
                         * Make some SiteCatalyst tracking
                         */
                        $(document).trigger('diy-editor-makeWebsiteFit', {
                            'condition': 'Tried',
                            'name': 'Web Apps'
                        });

                        $(document.body).trigger('WebAppInstalled.BSA');
                        $(document).trigger('diy-editor-appscatalog-wc-installed', [wc_id]);
                        diy.editor.siteadmin.api.destroyController('cc-sa-item-elements');
                        diy.editor.siteadmin.api.destroyController('cc-sa-item-appscatalog');
                        moduleSelector.default.jumpToWebComponent(wc_id, msg.data.main_category);
                    } else {
                        if (msg.errors.code_0
                            && appsApiConstants.errors[msg.errors.code_0]
                        ) {
                            responderObject.error(
                                appsApiConstants.errors[msg.errors.code_0]
                            );
                        } else {
                            //something unexpected
                            responderObject.error(
                                appsApiConstants.errors.INTERNAL_SERVER_ERROR
                            );
                        }
                    }
                }
            }
        );
        return;
    };
    /**
     * this responds to AppsCatalog request for installation status
     *
     * this method always responds back to the catalog;
     * does not send back an error (responderObject.error)
     * cuz it includes in normal response
     *
     * @author marian.cojoc@1and1.ro
     *
     * @param params //TODO: fill this in
     * @param responderObject //TODO: fill this in
     *
     */
    this.cb_getWebComponentStatus = function(params, responderObject){
        $.ajax(
            {
                url: controllerUrl + 'webapps-status-check',
                type: "post",
                dataType: "json",
                data: {wc_id_list: params.wc_id},
                success: function (msg) {
                    //the response came, get the response
                    if (msg.success === true ) {
                        var statuses = {};
                        for (var k in msg.data.status) {
                            if (msg.data.status.hasOwnProperty(k)) {
                                statuses[k] = {
                                    wc_id: k,
                                    status: appsApiConstants[msg.data.status[k]]
                                };
                            }
                        }
                        //all good
                        responderObject.respond(statuses);
                    } else {
                        //something unexpected
                        responderObject.error(
                            appsApiConstants.errors.INTERNAL_SERVER_ERROR
                        );
                    }
                }
            }
        );
    };

    /**
     * Checks if a webcomponent is installed or not
     *
     * @param wc_id webcomponent id
     * @returns {boolean}
     */
    this.isWebcomponentInstalled = function(wc_id) {
        return $.inArray(wc_id, jimdoData.installedWebcomponents) !== -1;
    };

    /**
     * this uninstalls the web component
     *
     * this is not a callback, this gets called directly by the module selector
     * when the delete button click is handled
     *
     * @author marian.cojoc@1and1.ro
     *
     * @param wc_id the web component id
     *
     */
    this.uninstallWebComponent = function(wc_id, params){
        var appIdToTrack = wc_id;
        $.ajax(
            {
                url: controllerUrl + 'webapps-uninstall',
                type: 'POST',
                dataType: 'json',
                data: {wc_id: wc_id},
                success: function (msg) {
                    if (msg.success === true) {
                        // Update status cache
                        var wcIndexInCache = $.inArray(wc_id, jimdoData.installedWebcomponents);
                        if (wcIndexInCache !== -1) {
                            jimdoData.installedWebcomponents.splice(wcIndexInCache, 1);
                        }

                        /**
                         * Make some SiteCatalyst tracking
                         */
                        $(document).trigger('diy-editor-appCatalog-uninstallWebApp', {
                            'appIdToTrack': appIdToTrack
                        });
                        $(document).trigger('diy-editor-appscatalog-wc-uninstalled', [wc_id]);
                        if (params.success) {
                            params.success(msg.data);
                        }
                    } else {
                        if (params.error) {
                            params.error();
                        }
                    }
                },
                error: function () {
                    if (params.error) {
                        params.error();
                    }
                }
            }
        );
    };

    this.cb_CNIFeatureIsAvailable = function (params, responderObject) {
        var time = new Date().getTime();
        $.ajax(
            {
                url: controllerUrl + 'webapps-feature-available?r=' + time,
                type: "GET",
                dataType: "json",
                success: function(msg){
                    //the response came, get the response
                    if (msg.success === true) {
                        //all good
                        responderObject.respond({
                            feature_is_available: msg.data.featureIsAvailable
                        });
                    } else {
                        //could not decide if the feature is avalable or not
                        responderObject.error(
                            appsApiConstants.errors.INTERNAL_SERVER_ERROR
                        );
                    }
                }
            }
        );
    };

    this.init = function (){

        // this event is triggered when closing the apps catalog siteadmin window if
        // it was opened form a link inside the module selector
        $(document).bind('diy-siteadmin-apps-catalog-closed', function(event) {
            //TODO: this gets logged twice INVESTIGATE
            // console.log(event.openModuleSelector);

            if(event.openModuleSelector){
                // use click instead of diy.editor.siteadmin.api.triggerSidebarItem() because
                // history changes are needed for the close button to work properly
                $('#cc-sa-item-elements').click();
            }
        });

        //register a receiver for when appsCatalog wants to know if CnI feature is available
        crossDomain.receiver.registerReceiver(
            appsApiConstants.REQUEST_FEATURE_IS_AVAILABLE,
            this.cb_CNIFeatureIsAvailable,
            jimdoData.messages.moduleSelector.catalog_url_prefix
        );

        //register a receiver for when appsCatalog wants statuses
        crossDomain.receiver.registerReceiver(
                appsApiConstants.REQUEST_STATUS,
                this.cb_getWebComponentStatus,
                jimdoData.messages.moduleSelector.catalog_url_prefix
        );
        //register for doFocus
        crossDomain.receiver.registerReceiver(
                appsApiConstants.REQUEST_FOCUS,
                this.cb_handleFocus,
                jimdoData.messages.moduleSelector.catalog_url_prefix
        );
        //register for install
        crossDomain.receiver.registerReceiver(
                appsApiConstants.REQUEST_INSTALL,
                this.cb_installWebComponent,
                jimdoData.messages.moduleSelector.catalog_url_prefix
        );
    };
}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/apps-catalog/appsCatalog.js
 ** module id = 11
 ** module chunks = 0
 **/